import { useState } from "react";
import { ViewportSize } from "../types";

export function useViewportSize() {
	const [viewportSize, setViewportSize] = useState<ViewportSize>("desktop");

	const getPreviewContainerStyle = () => {
		switch (viewportSize) {
			case "mobile":
				return { maxWidth: "375px", width: "100%", margin: "0 auto" };
			case "tablet":
				return { maxWidth: "768px", width: "100%", margin: "0 auto" };
			case "desktop":
				return { maxWidth: "100%", width: "100%" };
			default:
				return { width: "100%" };
		}
	};

	return { viewportSize, setViewportSize, getPreviewContainerStyle };
}
